module.exports = __webpack_public_path__ + "img/focus_letgo.3f4c1b1f.svg";